import { match } from 'ts-pattern';
import { Judge, RecentLevelParaEnum } from '~/apis/ssf';

export function toText(level: RecentLevelParaEnum) {
  return match(level)
    .with('D', () => 'Distriktsdomare')
    .with('F', () => 'Förbundsdomare')
    .with('K1', () => 'Kat 1. Domare')
    .with('K2', () => 'Kat 2. Domare')
    .otherwise(() => '');
}

export function useRefereeEligibilities(
  referee: Pick<Judge, 'is_non_para' | 'is_para'> & {
    recent_level: RecentLevelParaEnum | null;
    recent_level_para: RecentLevelParaEnum | null;
  }
) {
  const eligibilities = [];

  if (referee.is_non_para && referee.recent_level) {
    eligibilities.push(toText(referee.recent_level));
  }

  if (referee.is_para && referee.recent_level_para) {
    eligibilities.push(`Para ${toText(referee.recent_level_para)}`);
  }

  return eligibilities;
}
